import { useState } from 'react';
import '../styles/AuthForms.css';

function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-form">
        <h2 style={{ color: '#00FFFF', marginBottom: '1rem' }}>Check Your Email</h2>
        <div style={{
          background: 'rgba(0, 255, 255, 0.1)',
          padding: '1rem',
          borderRadius: '8px',
          border: '1px solid rgba(0, 255, 255, 0.3)',
          marginBottom: '1.5rem'
        }}>
          <p style={{ color: '#fff', margin: 0 }}>
            If an account exists with that email, you will receive a password reset link shortly.
          </p>
        </div>
        <button type="button" onClick={onBack} className="btn-secondary">
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <h2 style={{ color: '#00FFFF', marginBottom: '0.5rem' }}>Reset Password</h2>
      <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '1.5rem' }}>
        Enter your email and we'll send you a reset link
      </p>

      <form onSubmit={handleSubmit}>
        {error && (
          <div style={{
            background: 'rgba(255, 0, 0, 0.1)',
            border: '1px solid rgba(255, 0, 0, 0.3)',
            padding: '0.75rem',
            borderRadius: '6px',
            marginBottom: '1rem',
            color: '#ff6b6b'
          }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="email" style={{ color: '#fff' }}>Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.75rem',
              background: 'rgba(0, 0, 0, 0.3)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '6px',
              color: '#fff',
              fontSize: '1rem'
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="btn-primary"
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem'
          }}
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <button
          type="button"
          onClick={onBack}
          className="btn-secondary"
          style={{ width: '100%' }}
        >
          Back to Login
        </button>
      </form>
    </div>
  );
}

export default ForgotPasswordForm;
